var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['popup', (_vm.show) ? 'show' : '']},[_c('a',{staticClass:"close",attrs:{"href":"#"},on:{"click":function($event){return _vm.hide()}}},[_vm._v("×")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }